import { client, getUrl } from "utils";

export const getInitialScrapeTaskRequest = (filterParams) => {
    delete filterParams.sid;
    return client.post("initial-scrape-tasks/search", filterParams);
}

export const exportInitialScrapeTaskRequest = (filterParams) => client.post("initial-scrape-tasks/export", filterParams);

export const exportInitialScrapeTaskResultRequest = (pid) => client.post(`initial-scrape-tasks/export?pid=${pid}`);

export const createInitialScrapeTaskRequest = (data) => client.post("initial-scrape-tasks", data);

export const handleDeleteTasksRequest = (data) => client.delete(`initial-scrape-tasks`, data);

export const handlePatchTaskRequest = (task) => client.patch(`initial-scrape-task/${task.id}`, task);

export const handleRunTaskRequest = (data) => client.post(`initial-scrape-task/${data.id}/run`, data.body);

export const resendScrapedResultsRequest = ({ track_id, initial_track_id, storage_type_code, receiver_code }) => client.post(
    `scrape-task/${track_id}/resend-scraped-results?initial_track_id=${initial_track_id}&storage_type_code=${storage_type_code}&receiver_code=${receiver_code}`
);

export const oneTimeSearchRequest = (data) => client.post("initial-scrape-task/quick-start", data);

export const reschedulePidRequest = (filterParams) => client.post("initial-scrape-tasks/reschedule", filterParams);

export const deleteInitialScrapeTasksRequest = (filterParams) => client.delete(getUrl("initial-scrape-tasks", filterParams));

export const pidProcessRequest = (pid) => client.get(`process/${pid}`);

export const bulkUpdateRequest = (data) => client.put("initial-scrape-tasks", data);

export const partialUpdateMetadataRequest = (data) => client.patch("initial-scrape-task/metadata", data);

export const getCountSchedulerListRequest = (filterParams) => {
    delete filterParams.sid;
    return client.post("initial-scrape-tasks/search/count", filterParams);
}

export const updateAllByRequestRequest = ({ data, filterParams }) => {
    delete filterParams.sid;
    return client.patch(`initial-scrape-tasks`, {"selector": filterParams, "update": data});
}
